import { createContext, useContext } from 'react';

import type { InternalSliceData } from '../types/internal/pie-chart.js';

export const PieChartSlicesDataContext = createContext<{
  slices: InternalSliceData[];
}>({ slices: [] });

export const usePieChartSlicesData = () =>
  useContext(PieChartSlicesDataContext);
